export default {
  title: "This page has not been generated",
  subtitle: "Tell me more about this page, so I can generate it",
};